export const Card = ({ children }) => (
  <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-5 space-y-3">{children}</div>
);

export const Field = ({ label, value }) => {
  const isEmpty = value === null || value === undefined || value === "";
  return (
    <div className="flex items-start text-sm">
      <span className="w-40 shrink-0 text-xs font-medium text-gray-500 pt-px">{label}:</span>
      <span className="text-gray-900 min-w-0 flex-1">{isEmpty ? "—" : value}</span>
    </div>
  );
};
